var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('div',{staticClass:"app-main-scrollbar"},[_c('div',{staticClass:"app-main-container"},[(_vm.keepAlive)?_c('keep-alive',[_c('router-view',{key:_vm.key})],1):_vm._e(),(!_vm.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }